'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var jsxRuntime = require('react/jsx-runtime');

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _isCollapsed = typeof localStorage.getItem('is_collapsed') === 'string' ? localStorage.getItem('is_collapsed') === 'true' ? true : false : true;
var timeOut;
var ResizeContext = /*#__PURE__*/react.createContext({
  resizeLoading: false,
  windowWidth: 0,
  resizeDif: 0,
  isCollapsed: false,
  setIsCollapsed: function setIsCollapsed() {}
});
var ResizeProvider = function ResizeProvider(_ref) {
  var children = _ref.children;
  var _useState = react.useState(window.innerWidth),
    _useState2 = _slicedToArray(_useState, 2),
    windowWidth = _useState2[0],
    setWindowWidth = _useState2[1];
  var _useState3 = react.useState(_isCollapsed),
    _useState4 = _slicedToArray(_useState3, 2),
    isCollapsed = _useState4[0],
    setIsCollapsed = _useState4[1];
  var _useState5 = react.useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    loading = _useState6[0],
    setLoading = _useState6[1];
  var _useState7 = react.useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    dif = _useState8[0],
    setDif = _useState8[1];
  var resizeEvent = react.useCallback(function () {
    setLoading(true);
    clearTimeout(timeOut);
    timeOut = setTimeout(function () {
      var dif = window.innerWidth - windowWidth;
      setDif(dif);
      setWindowWidth(window.innerWidth);
      setLoading(false);
    }, 100);
  }, [windowWidth]);
  react.useEffect(function () {
    window.addEventListener('resize', resizeEvent);
    return function () {
      return window.addEventListener('resize', resizeEvent);
    };
  }, [resizeEvent]);
  return /*#__PURE__*/jsxRuntime.jsx(ResizeContext.Provider, {
    value: {
      resizeLoading: loading,
      windowWidth: windowWidth,
      resizeDif: dif,
      isCollapsed: isCollapsed,
      setIsCollapsed: setIsCollapsed
    },
    children: children
  });
};
var useResizeContext = function useResizeContext() {
  var values = react.useContext(ResizeContext);
  return values;
};

exports.ResizeProvider = ResizeProvider;
exports.useResizeContext = useResizeContext;
